import type { JobData } from "~/types/job";

export type JobDeadlineFields = Pick<JobData, "application_deadline_unlimited" | "expires_at">;

export function isApplicationDeadlineUnlimited(job: JobDeadlineFields | null | undefined): boolean {
	return job?.application_deadline_unlimited === true;
}

/**
 * Remaining days until the job application deadline (0 if already past).
 */
export function calcRemainingDays(expiresDate: string): number {
	const now = new Date();
	const endedDate = new Date(expiresDate.replace(" ", "T"));
	const difference = endedDate.getTime() - now.getTime();

	if (difference <= 0) {
		return 0;
	}

	// 1000 ms * 3600 s (1 hour) * 24 h = milliseconds in one day
	const days = Math.ceil(difference / (1000 * 3600 * 24));
	return days < 1 ? 1 : days;
}

export function jobExpiryFromApi(data: JobDeadlineFields): {
	remainingDays: number;
	expiredJob: boolean;
} {
	const unlimitedDeadline = isApplicationDeadlineUnlimited(data);
	const remainingDays = unlimitedDeadline ? 0 : data.expires_at ? calcRemainingDays(data.expires_at) : 0;
	const expiredJob = unlimitedDeadline ? false : remainingDays <= 0;

	return { remainingDays, expiredJob };
}
